import { GetTrialBackfillStatusResponse } from '@weave/schema-gen-ts/dist/schemas/call-intelligence/v2/call_intelligence.pb';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { SEVEN_DAYS_MS } from './constants';
import { TimedDismissState } from './types';

export interface BackfillUIFlags {
  hasPartialRecordingHistory: boolean;
  isBatch2InProgress: boolean;
  isFailed: boolean;
  isFirstBatchReady: boolean;
  isFullyComplete: boolean;
  isNotApplicable: boolean;
  isWaitingForLiveCalls: boolean;
  showLoadingState: boolean;
}

export const shouldShowTimedBanner = (dismiss: TimedDismissState): boolean => {
  if (dismiss.permanentlyDismissed) return false;
  if (!dismiss.dismissedAt) return true;

  const elapsed = Date.now() - dismiss.dismissedAt;
  return elapsed >= SEVEN_DAYS_MS;
};

export const deriveBackfillUIFlags = (status?: GetTrialBackfillStatusResponse): BackfillUIFlags => {
  if (!status) {
    return {
      showLoadingState: false,
      isFirstBatchReady: false,
      isFullyComplete: false,
      isFailed: false,
      isNotApplicable: false,
      isBatch2InProgress: false,
      isWaitingForLiveCalls: false,
      hasPartialRecordingHistory: false,
    };
  }

  const { aggregateState } = status;

  const showLoadingState =
    aggregateState === CallIntelTypes.TrialBackfillStateEnum.TRIAL_BACKFILL_STATE_PENDING ||
    aggregateState === CallIntelTypes.TrialBackfillStateEnum.TRIAL_BACKFILL_STATE_BATCH1_IN_PROGRESS;

  const isFirstBatchReady =
    aggregateState === CallIntelTypes.TrialBackfillStateEnum.TRIAL_BACKFILL_STATE_BATCH1_COMPLETE ||
    aggregateState === CallIntelTypes.TrialBackfillStateEnum.TRIAL_BACKFILL_STATE_BATCH2_IN_PROGRESS ||
    aggregateState === CallIntelTypes.TrialBackfillStateEnum.TRIAL_BACKFILL_STATE_FULLY_COMPLETE;

  const isFullyComplete = aggregateState === CallIntelTypes.TrialBackfillStateEnum.TRIAL_BACKFILL_STATE_FULLY_COMPLETE;
  const isFailed = aggregateState === CallIntelTypes.TrialBackfillStateEnum.TRIAL_BACKFILL_STATE_FAILED;
  const isNotApplicable = aggregateState === CallIntelTypes.TrialBackfillStateEnum.TRIAL_BACKFILL_STATE_NOT_APPLICABLE;
  const isBatch2InProgress =
    aggregateState === CallIntelTypes.TrialBackfillStateEnum.TRIAL_BACKFILL_STATE_BATCH2_IN_PROGRESS;
  const isWaitingForLiveCalls =
    aggregateState === CallIntelTypes.TrialBackfillStateEnum.TRIAL_BACKFILL_STATE_WAITING_FOR_LIVE_CALLS;

  const hasPartialRecordingHistory = status.locationStatuses?.some((loc) => !loc.batch1HasSufficientCalls) ?? false;

  return {
    showLoadingState,
    isFirstBatchReady,
    isFullyComplete,
    isFailed,
    isNotApplicable,
    isBatch2InProgress,
    isWaitingForLiveCalls,
    hasPartialRecordingHistory,
  };
};
